import { useHistory } from 'shared/hooks/useHistory';

export const HistoryContainer = () => {
  useHistory();

  return null;
};
